import { capture } from "./capture";

export const StudioTracking = {
  /** User sent a message in the studio chat. */
  messageSent: (sessionId: string, datamateId: string | null, messageLength: number) => {
    capture("studio.message_sent", {
      session_id: sessionId,
      datamate_id: datamateId,
      message_length: messageLength,
    });
  },

  /** An existing studio session was resumed. */
  sessionResumed: (sessionId: string) => {
    capture("studio.session_resumed", { session_id: sessionId });
  },

  /** User switched from one datamate to another. */
  datamateSwitched: (fromDatamateId: string, toDatamateId: string) => {
    capture("studio.datamate_switched", {
      from_datamate_id: fromDatamateId,
      to_datamate_id: toDatamateId,
    });
  },

  /** User saved a prompt to the prompt library. */
  promptSaved: (promptId: string) => {
    capture("studio.prompt_saved", { prompt_id: promptId });
  },

  /** User used a prompt from the prompt library. */
  promptUsed: (promptId: string) => {
    capture("studio.prompt_used", { prompt_id: promptId });
  },

  /** User deleted a prompt from the prompt library. */
  promptDeleted: (promptId: string) => {
    capture("studio.prompt_deleted", { prompt_id: promptId });
  },
};
